import * as React from 'react'
import styled from 'styled-components'
import { QuickWizardLoadingGrid } from 'src/components/containers/wizard/WizardContainer'
import QuickLoading from 'src/components/molecules/wizard/QuickLoading'
import { withRouter } from 'react-router'
import { StoreProps } from 'src/stores'
import { media } from '../../../utils'
import { inject } from 'mobx-react'

const Cookies = require('js-cookie')

const macVideo = require('src/assets/wizard/Benu-Scroll-Demo.m4v')
const phoneVideo = require('src/assets/wizard/Benu-Mobile-Scroll-Demo.m4v')
const macFallback = require('src/assets/wizard/mac-render-fallback.png')
const phoneFallback = require('src/assets/wizard/iphone-mockup-half.png')

interface Props extends StoreProps {
  history: any
}

interface State {
  uuidReady: boolean
}

@inject('wizardStore')
export class QuickWizardLoading extends React.Component<Props, State> {
  constructor(props) {
    super(props)
    this.state = { uuidReady: false }
  }

  componentDidMount() {
    const { wizardStore } = this.props
    const query = new URLSearchParams(location.search)
    if (query.has('planningReason'))
      wizardStore.basics.planningReason = query.get('planningReason')
    if (query.has('funeralType'))
      wizardStore.basics.funeralType = query.get('funeralType')
    if (query.has('zipCode'))
      wizardStore.location.zipCode = query.get('zipCode').slice(0, 4)
    if (query.has('previousPage'))
      wizardStore.basics.previousPage = query.get('previousPage')
    wizardStore.basics.gclId = query.get('gclid') || Cookies.get('_bn_gclid')
    wizardStore.basics.gaClientId = this.grabGaClientId()
    wizardStore.basics.previousPage = query.get('previousPage')
    wizardStore.createOffer((result) => {
      if (result) this.setState({ uuidReady: true })
    })
  }

  grabGaClientId() {
    const gaCookie = Cookies.get('_ga')
    const clientId = gaCookie ? gaCookie.split('.')[2] + "." + gaCookie.split('.')[3] : null
    return clientId;
  }

  finishedLoading = () => {
    const { history, wizardStore } = this.props
    history.replace('/planung/angebot/kontakt/' + wizardStore.uuid)
  }

  render() {
    const { uuidReady } = this.state
    return (
      <QuickWizardLoadingGrid>
        <div style={{ gridArea: 'loading' }}>
          <h2 style={{ textAlign: 'center', fontWeight: 'bold' }}>
            Ihr persönliches Angebot wird erstellt
          </h2>
          <Container>
            <QuickLoading
              loadingFinishedCallback={this.finishedLoading}
              uuidReady={uuidReady}
              isBurial={location.search.includes('BURIAL')}
            />
            <video
              id='mac-video'
              autoPlay
              muted
              playsInline
              poster={macFallback}
              width={200}>
              <source src={macVideo} type='video/mp4' />
              <img src={macFallback} />
            </video>
            <video
              id='mobile-video'
              autoPlay
              muted
              playsInline
              poster={phoneFallback}
              width={300}>
              <source src={phoneVideo} type='video/mp4' />
              <img src={phoneFallback} />
            </video>
          </Container>
        </div>
      </QuickWizardLoadingGrid>
    )
  }
}

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 30px;

  video {
    flex-basis: 40%;
  }

  #mobile-video {
    display: none;
  }

  ${media.tablet`
    #mobile-video {
      display: inline-block;
    }
    #mac-video {
      display: none;
    }
  `}

  ${media.tablet`
    flex-direction: column;
  `}
`

export default withRouter(QuickWizardLoading)



// WEBPACK FOOTER //
// ./src/components/organisms/wizard/QuickWizardLoading.tsx